import { render, staticRenderFns } from "./RiskAssements.vue?vue&type=template&id=09104624&"
import script from "./RiskAssements.vue?vue&type=script&lang=js&"
export * from "./RiskAssements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports